import { createReducer } from '@reduxjs/toolkit';

import postEasyShipShipment from '../../../thunks/shipment/easyShip/postEasyShipShipment';
import postEasyShipShipmentClearError from '../../../actions/shipment/easyShip/postEasyShipShipment';

const initialState = {
  loading: false,
  error: null,
  data: undefined,
};

const postEasyShipShipmentReducer = createReducer(initialState, {
  [postEasyShipShipment.pending]: (state) => ({
    ...state,
    loading: true,
    error: null,
  }),
  [postEasyShipShipment.fulfilled]: (state, { payload }) => ({
    ...state,
    loading: false,
    data: payload
  }),
  [postEasyShipShipment.rejected]: (state, { payload }) => ({
    ...state,
    loading: false,
    error: payload,
    data: undefined
  }),
  [postEasyShipShipmentClearError]: (state) => ({
    ...state,
    error: null,
  }),

});

export default postEasyShipShipmentReducer;
